module.exports = __webpack_public_path__ + "img/582-42dfb3.png";